var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPopoverArrowRight = function SvgPopoverArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.585 11.678a4 4 0 0 1 0 4.357L0 27.713V0l7.585 11.678Z",
    fill: "currentColor"
  })));
};

export { SvgPopoverArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDkgMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjU4NDgxIDExLjY3NzZDOC40NDU0NyAxMy4wMDI2IDguNDQ1NDcgMTQuNzEwMiA3LjU4NDgxIDE2LjAzNTJMLTEuMjExMzZlLTA2IDI3LjcxMjhMMCAtMy45MzQwM2UtMDdMNy41ODQ4MSAxMS42Nzc2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";